// Forecast component constants

// Polling and timing
export const POLL_INTERVAL_MS = 4000
export const HISTORY_REFETCH_ACTIVE_MS = 5000
export const HISTORY_REFETCH_IDLE_MS = 30000
export const ANALYSIS_FETCH_THRESHOLD = 20 // Fetch analysis at 20% progress
export const COPIED_FEEDBACK_DURATION_MS = 1200
export const STAGE_FEED_MAX_ITEMS = 10

// Storage keys
export const ACTIVE_FORECAST_KEY = 'cenva_active_forecast'

// Category colors and icons
// NOTE: Tailwind cannot statically analyze string interpolation like `bg-${color}/20`,
// so we keep explicit class strings here to ensure production builds include them.
export const categoryConfig: Record<string, { bgClass: string; textClass: string; icon: string }> = {
  Crypto: { bgClass: 'bg-signal-amber/20', textClass: 'text-signal-amber', icon: '₿' },
  Sports: { bgClass: 'bg-signal-green/20', textClass: 'text-signal-green', icon: '⚽' },
  Politics: { bgClass: 'bg-signal-red/20', textClass: 'text-signal-red', icon: '🏛' },
  Economics: { bgClass: 'bg-signal-blue/20', textClass: 'text-signal-blue', icon: '📊' },
  Tech: { bgClass: 'bg-signal-purple/20', textClass: 'text-signal-purple', icon: '💻' },
  Entertainment: { bgClass: 'bg-signal-amber/20', textClass: 'text-signal-amber', icon: '🎬' },
  Weather: { bgClass: 'bg-signal-blue/20', textClass: 'text-signal-blue', icon: '🌤' },
  Science: { bgClass: 'bg-signal-green/20', textClass: 'text-signal-green', icon: '🔬' },
  Business: { bgClass: 'bg-signal-blue/20', textClass: 'text-signal-blue', icon: '💼' },
  Other: { bgClass: 'bg-star-muted/20', textClass: 'text-star-muted', icon: '❓' },
}

// Agent icons for stage feed
export const agentIcons: Record<string, string> = {
  planner: '📋',
  news: '📰',
  quant: '📈',
  skeptic: '🛡️',
  baserate: '📚',
  synthesis: '🧠',
  validator: '✅',
  system: '⚙️',
  default: '✨',
}

// Stage icons and labels for analysis
export const stageIcons: Record<string, string> = {
  parsing: '🔍',
  identifying: '🎯',
  searching: '🌐',
  refining: '✨',
  complete: '✅',
}

export const stageLabels: Record<string, string> = {
  parsing: 'Parsing Question',
  identifying: 'Identifying Key Facts',
  searching: 'Searching for Details',
  refining: 'Refining Analysis',
  complete: 'Complete',
}

// Available categories for editing
export const CATEGORY_OPTIONS = [
  'Crypto',
  'Sports',
  'Politics',
  'Economics',
  'Tech',
  'Entertainment',
  'Weather',
  'Science',
  'Business',
  'Other',
] as const

// Example questions for empty state
export const EXAMPLE_QUESTIONS = [
  { category: 'Crypto', icon: '₿', text: 'Will BTC hit $150k by 2026?' },
  { category: 'Sports', icon: '⚽', text: 'Will Lakers win the championship?' },
  { category: 'Politics', icon: '🏛', text: 'Will Trump win the election?' },
  { category: 'Economics', icon: '📊', text: 'Will Fed cut rates in Q1?' },
] as const
